<aside class="sidebar" [class.sidebar--open]="isOpen()">
  <div class="sidebar__header">
    <div class="sidebar__brand">
      <span class="sidebar__brand-name">
        <span class="sidebar__brand-dura">DURA</span><span class="sidebar__brand-drive">DRIVE</span>
      </span>
      <span class="sidebar__brand-subtitle">Admin</span>
    </div>
    <button
      type="button"
      class="sidebar__close"
      (click)="onNavClick()"
      aria-label="Close navigation menu"
    >
      <app-icon name="x" [size]="20" />
    </button>
  </div>

  <nav class="sidebar__nav">
    @for (item of navItems; track item.route) {
      @if (item.enabled) {
        <a
          class="sidebar__nav-item"
          [routerLink]="[item.route]"
          routerLinkActive="sidebar__nav-item--active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="onNavClick()"
        >
          <app-icon [name]="item.icon" [size]="18" />
          <span>{{ item.label }}</span>
        </a>
      } @else {
        <span
          class="sidebar__nav-item sidebar__nav-item--disabled"
          [class.sidebar__nav-item--emphasized]="item.emphasized"
        >
          <app-icon [name]="item.icon" [size]="18" />
          <span>{{ item.label }}</span>
        </span>
      }
    }
  </nav>

  <div class="sidebar__footer">
    <button type="button" class="sidebar__action" (click)="onSignOut()">
      <app-icon name="log-out" [size]="16" />
      <span>Log Out</span>
    </button>
  </div>
</aside>
